

const cdpBaseUrl = 'https://cdp-nd-api.honasa-production.net';
const cdpUsername = 'hui_personalization_cust360';
const cdpPassword = 'sjbshcbjbh2bk2jupeddated3hd89h8hd3h983d';
const brandId = 4;

 function uuidv4() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
    
   let webId = window.localStorage.getItem('device_id');
    if(!webId){
        webId = uuidv4();
        window.localStorage.setItem('device_id', JSON.stringify(webId));
        window.localStorage.setItem('setDeviceIdOnAB',JSON.stringify(true));
    }
       webId = webId.replaceAll('"', '');
    const response = fetch(
          cdpBaseUrl + '/v1/experiment/' + brandId + '/' + webId, {
        method: 'GET',
        headers: {
            'username': cdpUsername,
            'password': cdpPassword 
        }
    })

    let mefe = {};
    let experiments = [];
   let variants = [];
   let experimentIds='';
   let variantIds='';
    response.then((response) => {
        response.json().then((experimentData) => {
            if (typeof window !== 'undefined') {
                window._me_fe_ = {}
                window.cdp_ab_exp=experimentData;

                experimentData.forEach(exp => {
                    window._me_fe_[exp.flag.key] = exp.flag.value;
                    let flagKey = exp?.flag?.key;
                    let flagVal = exp?.flag?.value;
                  if(flagKey){
                    mefe = mefe || {};
                   mefe[flagKey] = flagVal;
                     } 
                 if(exp?.experimentId){
                    experiments.push(exp?.experimentId)
                  }
                if(exp?.variantId){
                     variants.push(exp?.variantId);
                  }
                })
                // window.localStorage.setItem('_me_fe_', JSON.stringify(window._me_fe_));
                experimentIds = experiments && experiments?.join?.(",");
                variantIds = variants && variants?.join?.(",");
                let cdpExp = {
                    variants:mefe,
                    experimentIds,
                    variantIds,
                    device_id:webId
                }
                window.cdp_ab_exp=cdpExp;
                window.localStorage.setItem('cdp_ab_exp', JSON.stringify(cdpExp));
                // if(typeof window !== "undefined" && window.dataLayer && cdp_ab_exp && cdp_ab_exp?.device_id){
                //     dataLayer.push({
                //         event:'pageview_custom',
                //         experiment_id:cdp_ab_exp?.experimentIds ,
                //         device_id: cdp_ab_exp?.device_id,
                //         variant_id: cdp_ab_exp?.variantIds,
                //         type:'page_load'
                //       })
                //     }
            }
        })
    })


    
